import { BufferAttribute, StaticDrawUsage } from "three";
import { repeatVectorInline, setVector } from "../../../helpers/buffers";

export default class BufferAttr {
  constructor(name, maxCount, size, vertices, Type) {
    const step = size * vertices;
    const length = maxCount * step;
    this.buffer = new BufferAttribute(new Type(length), size);
    this.step = step;
    this.size = size;
    this.name = name;
    this.itemCount = 0;
    this.buffer.setUsage(StaticDrawUsage);
  }

  setRangeReadable(off, cnt) {
    const offset = off * this.step;
    const count = cnt * this.step;
    this.buffer.addUpdateRange(offset, count);
  }

  updateItemCount(count, isAppending) {
    if (isAppending) {
      const offset = this.itemCount;
      this.itemCount += count;
      this.setRangeReadable(offset, count);
    } else {
      this.itemCount = count;
      this.buffer.addUpdateRange(0, count * this.step);
    }
    this.buffer.needsUpdate = true;
  }

  fillWithVec(newItemCount, vec) {
    const times = newItemCount - this.itemCount;
    if (times < 0) return;
    const startInd = this.itemCount * this.step;
    const arr = this.buffer.array;
    repeatVectorInline(vec, times, arr, startInd);
    this.updateItemCount(times, true);
  }

  fillWithPattern(newItemCount, pattern, repeatOffset = 0) {
    const times = newItemCount - this.itemCount;

    // TODO repeat offset - 1
    if (times < 0) return;
    const patternLength = pattern.length;
    const patternSize = new Set(pattern).size;
    const increment = patternSize + repeatOffset;
    const arr = this.buffer.array;
    for (
      let r = this.itemCount;
      r < newItemCount - (repeatOffset ? 1 : 0);
      r++
    ) {
      const inc = r * increment;
      for (let i = 0; i < patternLength; i++) {
        const index = r * patternLength + i;
        arr[index] = pattern[i] + inc;
      }
    }
    this.updateItemCount(times, true);
  }

  set(i, val) {
    this.buffer.array[i] = val;
  }

  setTo(i, vec) {
    setVector(i, this.buffer.array, vec || []);
  }

  setVec(i, vec) {
    setVector(i * this.step, this.buffer.array, vec || []);
  }

  copyFrom(prev) {
    for (let i = 0; i < prev.array.length; i++) {
      this.buffer.array[i] = prev.array[i];
    }
  }
}
